import { useState } from "react";
import { useNavigate } from "react-router-dom";
import * as Sentry from "@sentry/react";
import { Onboarding } from "sdk/onboardings";
import { routes } from "~/constants";
import { useAuthN } from "~/hooks/useAuthN";
import { useTrialOffersUpdateMutation } from "~/store/api";
import { trackActivate as track } from "../events";
import { usePartner } from "./usePartner";

interface Values {
  code: string;
}

interface UseSubmitTrialActivation extends Partial<Onboarding> {
  onSubmit: (code: Values) => Promise<void>;
  errorMessage: string | null;
}

export const useSubmitTrialActivation = (): UseSubmitTrialActivation => {
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const [apiTrialOffersUpdate] = useTrialOffersUpdateMutation();
  const navigate = useNavigate();
  const { refreshCurrentUser } = useAuthN();
  const { partnerSlug } = usePartner();

  const onSubmit = async (values: Values) => {
    try {
      await apiTrialOffersUpdate(values).unwrap();
      await refreshCurrentUser();
      track.partnerCodeRedeemed(partnerSlug, values.code);
      navigate(`${routes.setPassword}?partner=true`);
    } catch (err: any) {
      const msg =
        err?.data?.message || "An error has occurred; please try again later";

      setErrorMessage(msg);
      Sentry.captureException(err);
    }
  };

  return {
    errorMessage,
    onSubmit,
  };
};
